import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import HomePage from './pages/HomePage';
import CorporateTrainingPage from './pages/CorporateTrainingPage';
import RecruitmentPage from './pages/RecruitmentPage';
import SoftwareDevelopmentPage from './pages/SoftwareDevelopmentPage';
import ITServicesPage from './pages/ITServicesPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import CertificationFrameworkPage from './pages/CertificationFrameworkPage';
import CertificationLevelsPage from './pages/CertificationLevelsPage';
import VerifyCertificationPage from './pages/VerifyCertificationPage';
import DigitalCredentialsPage from './pages/DigitalCredentialsPage';
import BookConsultationPage from './pages/BookConsultationPage';
import BlogPage from './pages/BlogPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import CourseComparisonPage from './pages/CourseComparisonPage';
import FAQPage from './pages/FAQPage';
import NotFoundPage from './pages/NotFoundPage';
import LeadCapturePopup from './components/LeadCapturePopup';
import { Toaster } from './components/ui/sonner';

// Google Analytics tracking component
const GoogleAnalytics = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-C4X6P27SQQ', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);
  
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <GoogleAnalytics />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/corporate-training" element={<CorporateTrainingPage />} />
            <Route path="/recruitment" element={<RecruitmentPage />} />
            <Route path="/software-development" element={<SoftwareDevelopmentPage />} />
            <Route path="/it-services" element={<ITServicesPage />} />
            <Route path="/certifications/framework" element={<CertificationFrameworkPage />} />
            <Route path="/certifications/levels" element={<CertificationLevelsPage />} />
            <Route path="/verify" element={<VerifyCertificationPage />} />
            <Route path="/certifications/digital-credentials" element={<DigitalCredentialsPage />} />
            <Route path="/book-a-consultation" element={<BookConsultationPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/success-stories" element={<SuccessStoriesPage />} />
            <Route path="/courses" element={<CourseComparisonPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <LeadCapturePopup />
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
